import { render, staticRenderFns } from "./AutomaticCommentaryList.vue?vue&type=template&id=06d761f1&scoped=true"
import script from "./AutomaticCommentaryList.vue?vue&type=script&lang=js"
export * from "./AutomaticCommentaryList.vue?vue&type=script&lang=js"
import style0 from "./AutomaticCommentaryList.vue?vue&type=style&index=0&id=06d761f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d761f1",
  null
  
)

export default component.exports